import React from 'react';

const SECTIONS = [
  ['01', 'Preliminaries', 3, null],
  ['02', 'Strip out', 2, null],
  ['03', 'Walls and ceiling', 4, '1,452', true],
  ['04', 'Floor', 3, null],
  ['05', 'Units and worktops', 6, null],
  ['06', 'Splashback', 1, '396'],
  ['07', 'Plumbing and gas', 5, null],
  ['08', 'Electrical', 6, null],
  ['09', 'Ventilation', 1, '280'],
  ['10', 'Appliances', 1, null],
  ['11', 'Decorations', 3, '546', true],
];
const TOTALS = ['Works total', 'Contingency 10%', 'VAT 20%', 'Total including VAT'];

const Redacted = () => <span className="fm-redact" aria-label="Hidden in example" title="Hidden in example" />;

export const ExampleSchedule = () => (
  <div className="fm-sched" data-testid="example-schedule">
    <div className="fm-sched-hdr">
      <span className="fm-sched-title">Kitchen refurbishment <span className="fm-sched-dim">· 20.0 m² · Standard finish</span></span>
      <span className="fm-sched-label">Example</span>
    </div>
    <div className="fm-tbl-scroll">
      <table className="fm-sched-table">
        <thead>
          <tr><th>Ref</th><th>Section</th><th className="num">Items</th><th className="num">Cost £</th></tr>
        </thead>
        <tbody>
          {SECTIONS.map(([ref, name, items, cost, flag]) => (
            <tr key={ref} className={flag ? 'flag' : ''} data-testid={`hero-sec-${ref}`}>
              <td className="ref">{ref}</td>
              <td>
                {name}
                {flag && <span className="fm-sched-tag">Check your quote includes this</span>}
              </td>
              <td className="num">{items}</td>
              <td className="num">{cost || <Redacted />}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          {TOTALS.map((label) => (
            <tr key={label} className={label === 'Total including VAT' ? 'grand' : 'sub'} data-testid={`hero-total-${label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}>
              <td />
              <td colSpan={2}>{label}</td>
              <td className="num"><Redacted /></td>
            </tr>
          ))}
        </tfoot>
      </table>
    </div>
  </div>
);
